var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link",attrs:{"href":_vm.vitnPath}},[_c('i',{staticClass:"fa fa-diamond mr-1"}),_c('span',{staticClass:"d-inline-block vitn-count"},[_vm._v(_vm._s(_vm.user ? _vm.user.vitn : 0))])])}
var staticRenderFns = []

export { render, staticRenderFns }